import React from "react";
import ReactDOM from "react-dom/client";

import { ThemeProvider } from "@/ui/ThemeProvider";
import { ViewToasts, queryClient } from "@/ui/compositionRootUI";
import QueryProvider from "@/queries/QueryProvider";

import ErrorBoundary from "@/ui/organisms/ErrorBoundary";

import Router from "@/ui/router/Router";
import DragDropPreventer from "./ui/organisms/DragDropPreventer";

import "../public/icons/css/proda.min.css";

export const RootApp = () => {
    return (
        <React.StrictMode>
            <ErrorBoundary>
                <QueryProvider queryClient={queryClient}>
                    <DragDropPreventer>
                        <ThemeProvider>
                            <Router />
                            <ViewToasts />
                        </ThemeProvider>
                    </DragDropPreventer>
                </QueryProvider>
            </ErrorBoundary>
        </React.StrictMode>
    );
};

const rootElement = document.getElementById("root");
if (rootElement) {
    ReactDOM.createRoot(rootElement).render(<RootApp />);
}
